import { mergeForSlice, arrToObj } from '../../utils/array';

const initialState: any = {
  data: [],
  map: {}
};

export const ADD: string = 'FAVORITE/ADD'; 
export const REMOVE: string = 'FAVORITE/REMOVE'; 

type UserAction = any;

export const addFavorite = (payload: {coin: string}) => (dispatch: any) => {
  dispatch({
    type: ADD,
    payload
  })
}
export const removeFavorite = (payload: {coin: string}) => (dispatch: any) => {
  dispatch({
    type: REMOVE,
    payload
  })
}

function cobitReducer(state: any = initialState, action: UserAction) {
  let tempData = [...state.data];
  let map = {...state.map};
  let coin = "";

  switch (action.type) {
    case ADD:
      coin = action.payload.coin;
      
      if (!map[coin]) {
        tempData.push(coin);
        map = arrToObj(tempData);
      }

      return {
        data: tempData,
        map
      };
    
    case REMOVE:
      coin = action.payload.coin
      let index = map[coin];

      let newData = mergeForSlice(tempData, index);

      return {
        data: newData,
        map: arrToObj(newData)
      };
    
    default:
      return state;
  }
}

export default cobitReducer;
